import { QueryKey, UseQueryOptions } from 'react-query'

export const NO_REFETCH_OPTIONS: Pick<
  UseQueryOptions<any, unknown, any, QueryKey>,
  'refetchOnMount' | 'refetchOnReconnect' | 'refetchOnWindowFocus'
> = {
  refetchOnMount: false,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
}
